module.exports = __webpack_public_path__ + "img/Logo1.35c3b866.jpg";